import * as Yup from 'yup';

const EditTaskSchema = Yup.object().shape({
    taskId: Yup.string().max(10, 'Maximum 10 characters'),
});

export default EditTaskSchema;
